import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { firebaseApp } from "./firebase";
import { deleteImage, deleteVideoFile } from "./firebaseStorage";

const db = getFirestore(firebaseApp);

export const createAdvertisementFB = (value, navigate) => {
  addDoc(collection(db, "advertisements"), { ...value, publishedDate: new Date().toJSON() });
  navigate("/");
};

export const editAdvertisement = async (value, navigate) => {
  await setDoc(doc(db, "advertisements", value?.id), {
    ...value,
    publishedDate: value?.publishedDate || new Date().toJSON(),
    lastUpdatedDate: new Date().toJSON(),
  });
  navigate("/");
};

export const deleteCampaign = async (value, getUpdate, setModal) => {
  const querySnapshotAds = await getDocs(collection(db, "advertisements"));
  const has = querySnapshotAds.docs.some((doc) => doc.data().campaignId === value?.id);
  if (has) {
    alert("Campaign has ads, delete them first");
    setModal(false);
  }
  await deleteDoc(doc(db, "campaigns", value.id));
  getUpdate();
  setModal(false);
};

export const getAds = async () => {
  const querySnapshotCampaigns = await getDocs(collection(db, "campaigns"));
  const eventsSnapshot = await getDocs(collection(db, "events"));
  let campaignsListById = {};

  querySnapshotCampaigns.docs.map((campaign) => {
    campaignsListById[campaign.id] = campaign.data();
  });

  const querySnapshot = await getDocs(collection(db, "advertisements"));
  return querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    campaign: doc?.data()?.campaignId ? campaignsListById[doc?.data()?.campaignId] : null,
    events: eventsSnapshot.docs
      .filter((eventDoc) => eventDoc.data().advertisement_id === doc.id)
      .map((eventDoc) => ({
        id: eventDoc.id,
        ...eventDoc.data(),
      })),
  }));
};

export const getStoreCampaigns = async () => {
  const campaignsSnapshot = await getDocs(collection(db, "campaigns"));
  const adsSnapshot = await getDocs(collection(db, "advertisements"));

  const advertisements = adsSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return campaignsSnapshot.docs.map((campaignDoc) => {
    const campaignId = campaignDoc.id;

    const campaignAds = advertisements.filter((ad) => ad.campaignId === campaignId);

    return {
      id: campaignId,
      ...campaignDoc.data(),
      campaignAds,
    };
  });
};

export const getAdEvents = async () => {
  const advertisementsSnapshot = await getDocs(collection(db, "advertisements"));
  const eventsSnapshot = await getDocs(collection(db, "events"));

  const advertisements = advertisementsSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    events: eventsSnapshot.docs
      .filter((eventDoc) => eventDoc.data().advertisement_id === doc.id)
      .map((eventDoc) => ({
        id: eventDoc.id,
        ...eventDoc.data(),
      })),
  }));

  return advertisements;
};

export const getOneAd = async (id) => {
  const docRef = doc(db, "advertisements", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};

function getPathFromUrl(url) {
  const decoded = decodeURIComponent(url);
  return decoded.split("/o/")[1].split("?")[0];
}

export const deleteAdvertisement = async (id) => {
  const docRef = doc(db, "advertisements", id);
  const docSnap = (await getDoc(docRef)).data();
  if (docSnap?.mediaType === "video") {
    await deleteVideoFile(docSnap?.video?.id);
  } else {
    if (docSnap?.desktop_image) {
      await deleteImage(docSnap?.desktop_image?.id);
    }
    if (docSnap?.image) {
      await deleteImage(docSnap?.image?.id);
    }
  }
  await deleteDoc(doc(db, "advertisements", id));
};

// assets/firebaseFirestore.js
export const createCampaignFB = async (data, navigate) => {
  try {
    const campaignsRef = collection(db, "campaigns");
    const docRef = await addDoc(campaignsRef, {
      ...data,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
    navigate("/campaigns");
  } catch (error) {
    console.error("Error creating campaign: ", error);
  }
};

export const editCampaign = async (data, navigate) => {
  try {
    const campaignRef = doc(db, "campaigns", data.id);
    await updateDoc(campaignRef, {
      ...data,
      updatedAt: new Date().toISOString(),
    });
    navigate("/campaigns");
  } catch (error) {
    console.error("Error updating campaign: ", error);
  }
};

export const getOneCampaign = async (id) => {
  try {
    const campaignRef = doc(db, "campaigns", id);
    const campaignSnap = await getDoc(campaignRef);

    if (campaignSnap.exists()) {
      return { id: campaignSnap.id, ...campaignSnap.data() };
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};
